<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <form
                    action=""
                    @submit.prevent="saveProduct"
                >
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group">
                                <label for="product_name">Product Name</label>
                                <input
                                    type="text"
                                    id="product_name"
                                    placeholder="Product Name"
                                    v-model="product.name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.name }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.name"
                                >{{ errors.name[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="product_code">Product Code</label>
                                <input
                                    type="text"
                                    id="product_code"
                                    placeholder="Product Code"
                                    v-model="product.code"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.code }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.code"
                                >{{ errors.code[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="product_unit_price">Product Unit Price</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span
                                            class="input-group-text"
                                        >£</span>
                                    </div>
                                    <input
                                        type="number"
                                        step="0.01"
                                        min="0"
                                        id="product_unit_price"
                                        placeholder="10.00"
                                        v-model="product.unit_price"
                                        class="form-control"
                                        style="max-width: 10em"
                                        :class="{ 'is-invalid' : errors.unit_price }"
                                    >
                                </div>
                                <small
                                    class="form-error"
                                    v-if="errors.unit_price"
                                >{{ errors.unit_price[0] }}</small>
                            </div>

                            <div class="form-group">
                                <label for="category_id">Category</label>
                                <div class="input-group">
                                    <select
                                        v-model="product.category_id"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="category in categories"
                                            :key="category.id"
                                            :value="category.id"
                                        >
                                            {{ category.name }}
                                        </option>
                                    </select>
                                </div>
                                <small
                                    class="form-error"
                                    v-if="errors.unit_price"
                                >{{ errors.unit_price[0] }}</small>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label>Product Photo</label>
                                <div v-if="product.photo_url">
                                    <img
                                        :src="product.photo_url"
                                        class="product-img"
                                    >
                                </div>
                                <div>
                                    <label class="btn btn-info btn-upload">
                                        <input
                                            type="file"
                                            id="file"
                                            accept="image/*"
                                            @change="handleFileUpload"
                                        >
                                        Upload photo
                                    </label>
                                    <button
                                        class="btn btn-danger"
                                        v-if="product.photo_url"
                                        @click.prevent="deletePhoto"
                                    >
                                        Delete Photo
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label for="product_unit_price">Product Text</label>
                                <textarea
                                    v-model="product.text"
                                    class="form-control"
                                    rows="4"
                                    placeholder="Product text..."
                                />
                                <small
                                    class="form-error"
                                    v-if="errors.unit_price"
                                >{{ errors.unit_price[0] }}</small>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <button
                                class="btn btn-primary"
                                :disabled="loading"
                            >
                                <i class="fa fa-save" />
                                Save Product
                            </button>
                            <button
                                v-if="product.id"
                                @click.prevent="deleteProduct"
                                :disabled="loading"
                                class="btn btn-danger"
                            >
                                <i class="fa fa-times" />
                                Delete Product
                            </button>
                            <router-link
                                :to="{name: 'products'}"
                                class="btn btn-info"
                            >
                                <i class="fa fa-chevron-left" />
                                Back to Products
                            </router-link>
                            <span v-if="loading">
                                Loading, please wait... <i class="fa fa-spinner fa-spin" />
                            </span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import ProductsService from '../../../services/ProductsService';
import CategoriesService from '../../../services/ProductCategoriesService';
import UploadService from '../../../services/UploadService';
import UsesErrors from '../../../mixins/UsesErrors';
import UsesInfoMessage from '../../../mixins/UsesInfoMessage';

export default {
    mixins: [UsesErrors, UsesInfoMessage],
    data () {
        return {
            product: {},
            loading: false,
            categories: [],
        };
    },

    watch: {
        $route () {
            this.loadProduct();
        }
    },

    mounted () {
        this.loadProduct();
        this.loadCategories()
    },

    methods : {
        saveProduct () {
            this.loading = true;
            this.clearErrors();
            ProductsService.save(this.product).then(res => {
                if (this.product.id) {
                    this.product = res.data;
                    return;
                }

                this.$router.push({name: 'products.edit', params: {id: res.data.id}});
            }).catch(err => {
                this.captureRequestErrors(err);
            }).then(() => {
                this.loading = false;
            });
        },

        loadProduct () {
            if (this.$route.params.id) {
                this.loading = true;
                ProductsService.get(this.$route.params.id).then(res => {
                    this.product = res.data;
                }).catch(() => {
                    this.showErrorMessage('Error: Failed to load product');
                    this.$router.replace({name: 'products'});
                }).then(() => {
                    this.loading = false;
                });
                return;
            }
            this.product = {};
        },

        loadCategories () {
            CategoriesService.index().then(res => {
                this.categories = res.data;
            });
        },

        handleFileUpload($event) {
            let file = $event.target.files[0];
            UploadService.upload(file, 600).then(res => {
                this.product.photo_url = res.data.full_url;
                this.product.photo_path = res.data.full_path;
                this.$forceUpdate();
            });
        },

        deletePhoto() {
            var confirm = window.confirm(
                "Are you sure you want to delete this photo?"
            );
            if (!confirm) {
                return;
            }
            UploadService.delete(this.product.photo_path).then(() => {
                this.product.photo_url = null;
                this.product.photo_path = null;
                this.$forceUpdate();
            }).catch(err => {
                this.showErrorMessage('Error: Failed to delete photo');
                throw err;
            });
        },

        deleteProduct () {
            const confirm  = window.confirm('Are you sure you want to delete this product?');
            if (!confirm) {
                return;
            }
            this.loading = true;
            ProductsService.delete(this.product.id).then(() => {
                this.$router.replace({name: 'products'});
            }).catch(err => {
                this.showErrorMessage('Error: Failed to delete the product');
                throw err;
            }).then(() => {
                this.loading = false;
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/products/EditComponent.vue